import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import Scrapers from './components/Scrapers';
import UpcomingFights from './components/UpcomingFights';
import Settings from './components/Settings';
import Login from './components/Login';
import AdminUsers from './components/AdminUsers';
import FighterProfile from './components/FighterProfile';
import ModelInfo from './components/ModelInfo';
import './App.css';

function App() {
  const [user, setUser] = useState(undefined); // undefined = loading, null = not logged in
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    fetch('/api/auth/me', { credentials: 'include' })
      .then(r => r.json())
      .then(data => setUser(data.user || null))
      .catch(() => setUser(null));
  }, []);

  const handleLogout = async () => {
    await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
    setUser(null);
  };

  if (user === undefined) {
    return <div className="loading" style={{ paddingTop: '30vh' }}>Loading...</div>;
  }

  if (user === null) {
    return <Login setUser={setUser} />;
  }

  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <div className="nav-brand">
            <h1>Moon Bets</h1>
          </div>
          <button className="nav-hamburger" onClick={() => setMenuOpen(v => !v)} aria-label="Menu">
            <span /><span /><span />
          </button>
          <div className={`nav-links ${menuOpen ? 'nav-open' : ''}`}>
            <Link to="/" onClick={() => setMenuOpen(false)}>Fights</Link>
            <Link to="/fighters" onClick={() => setMenuOpen(false)}>Fighters</Link>
            <Link to="/model" onClick={() => setMenuOpen(false)}>Model</Link>
            {user.is_admin && <Link to="/scrapers" onClick={() => setMenuOpen(false)}>Scrapers</Link>}
            <Link to="/settings" onClick={() => setMenuOpen(false)}>Settings</Link>
            {user.is_admin && <Link to="/admin" onClick={() => setMenuOpen(false)}>Admin</Link>}
          </div>
          <div className="nav-user">
            <span className="nav-username">{user.username}</span>
            {user.is_admin && <span className="nav-admin-badge">Admin</span>}
            <button className="nav-logout-btn" onClick={handleLogout}>Sign Out</button>
          </div>
        </nav>

        <div className="container">
          <Routes>
            <Route path="/" element={<UpcomingFights />} />
            <Route path="/upcoming" element={<Navigate to="/" replace />} />
            <Route path="/fighters" element={<FighterProfile />} />
            <Route path="/fighters/:id" element={<FighterProfile />} />
            <Route path="/model" element={<ModelInfo />} />
            <Route path="/settings" element={<Settings user={user} />} />
            {user.is_admin && <Route path="/scrapers" element={<Scrapers />} />}
            {user.is_admin && <Route path="/admin" element={<AdminUsers />} />}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
